// @mui
import { LoadingButton } from '@mui/lab';
import { Popover, Typography } from '@mui/material';
import { MouseEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/iconify';
import { GetVisitById, PaymentStatusEnum } from 'woofwoof-api';

// ---------------------------------------------------------------------

type UserUpcomingVisitCardCancelButtonProps = {
  visit: GetVisitById;
  onCancel: (visitId: string) => void;
  isRescheduleOrCancelAvailable?: boolean;
  isCancelLoading?: boolean;
  isRescheduleLoading?: boolean;
  disabled?: boolean;
  isIcon?: boolean;
  size?: 'small' | 'medium' | 'large';
};

export default function UserUpcomingVisitCardCancelButton({
  visit,
  onCancel,
  isRescheduleOrCancelAvailable,
  isCancelLoading,
  isRescheduleLoading,
  disabled,
  isIcon,
  size,
}: UserUpcomingVisitCardCancelButtonProps) {
  const { t } = useTranslation();
  const isPaymentFailed = visit?.payment?.status === PaymentStatusEnum.Failed;
  const isPaymentPending = visit?.payment?.status === PaymentStatusEnum.Created;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handlePopoverOpen = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      !isRescheduleOrCancelAvailable && setAnchorEl(event.currentTarget);
    },
    [isRescheduleOrCancelAvailable],
  );

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleOnCancelVisitClick = () => onCancel(visit.id);

  return (
    <>
      <span
        aria-owns={open ? 'cancel-popover' : undefined}
        aria-haspopup="true"
        // onMouseEnter={handlePopoverOpen}
        // onMouseLeave={handlePopoverClose}
        style={{ display: 'inline-flex' }}
      >
        <LoadingButton
          variant="outlined"
          color="error"
          size={size || 'medium'}
          fullWidth
          startIcon={isIcon ? <Iconify icon="ic:close" /> : undefined}
          onClick={handleOnCancelVisitClick}
          loading={isCancelLoading}
          disabled={
            isPaymentFailed ||
            isPaymentPending ||
            // !isRescheduleOrCancelAvailable ||
            isCancelLoading ||
            isRescheduleLoading ||
            disabled
          }
        >
          {t('visit.cancelVisitShort')}
        </LoadingButton>
      </span>
      <Popover
        id="cancel-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography variant="body2" sx={{ p: 1, maxWidth: '350px' }}>
          {t('visit.cancelMinHoursNotice')}
        </Typography>
      </Popover>
    </>
  );
}
